import PropTypes from 'prop-types';
import React from 'react';
import AddressFields from 'react/shared/components/true_link/main/form/address_input/AddressFields';
import CountryOfCitizenship from 'react/shared/components/true_link/main/form/country_of_citizenship/CountryOfCitizenship';
import TrueLinkMaskedTextInput from 'react/shared/components/true_link/main/form/masked_text_input/TrueLinkMaskedTextInput';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/radios/TrueLinkRadios';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import { possessiverize } from 'react/shared/utils/Strings';
import AddressRadioLabel from 'react/signups/card/common/AddressRadioLabel';
import addressShape from 'react/signups/card/shapes/AddressShape';
import cardholderProfileShape from 'react/signups/card/shapes/CardholderProfile';

export default function CardholderProfileForm({
  onChange,
  organizationAddress,
  setFieldTouched,
  firstName,
  setValues,
  values,
}) {
  const name = possessiverize(firstName);
  const dateOfBirthLabel = `${name} date of birth`;
  const mobileLabel = `${name} phone number (Optional)`;
  const countryOfCitizenshipLabel = `${name} country of citizenship`;
  const nonResidentAlienLabel = `Is ${firstName} a non-resident alien?`;

  const options = [
    {
      label: (
        <AddressRadioLabel
          address={organizationAddress}
          description="We live at the same address"
        />
      ),
      value: 'true',
    },
    {
      label: 'Add a separate address',
      value: 'false',
    },
  ];

  return (
    <>
      <CardText>Now we need some information about the cardholder, {firstName}.</CardText>
      <TrueLinkRadios
        ariaLabel="We live at the same address"
        name="sameAddress"
        onChange={onChange}
        options={options}
        value={values.sameAddress}
      />

      {values.sameAddress == 'false' && (
        <AddressFields
          labelPrefix="Cardholder"
          setFieldTouched={setFieldTouched}
          setValues={setValues}
          showPoBoxWarning
          values={values}
        />
      )}
      <TrueLinkMaskedTextInput
        labelText={dateOfBirthLabel}
        mask="99/99/9999"
        name="dateOfBirth"
        onChange={onChange}
        placeholder="MM/DD/YYYY"
        required
        setFieldTouched={setFieldTouched}
        value={values.dateOfBirth}
      />
      <CountryOfCitizenship
        countryOfCitizenshipLabel={countryOfCitizenshipLabel}
        nonResidentAlienLabel={nonResidentAlienLabel}
        onChange={onChange}
        required
        setFieldTouched={setFieldTouched}
        values={values}
      />
      <TrueLinkMaskedTextInput
        labelText={mobileLabel}
        mask="999-999-9999"
        name="mobile"
        onChange={onChange}
        placeholder="(555) 555 - 5555"
        required
        setFieldTouched={setFieldTouched}
        value={values.mobile}
      />
    </>
  );
}

CardholderProfileForm.propTypes = {
  firstName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  organizationAddress: addressShape.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  values: cardholderProfileShape.isRequired,
};
